import axios from 'axios';
// config
// import { HOST_API } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  // baseURL: 'https://ilogixtool.dev-hi.xyz/api/'
  baseURL: 'https://newilogixtool.dev-hi.xyz/api/'
});


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
